export function DocSvg(props) {
  return (
    <svg viewBox="0 0 11 15" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M21.836 4.689a.746.746 0 00-.745.745v10.732c0 .411.334.745.745.745h7.154a.746.746 0 00.745-.745V8.862h-2.533a1.64 1.64 0 01-1.64-1.64V4.69h-3.726zm4.62.633l2.647 2.646h-1.901a.746.746 0 01-.746-.745V5.322zm-6.26.112c0-.905.734-1.64 1.64-1.64h4.173c.119 0 .233.048.316.132L30.5 8.099a.445.445 0 01.13.316v7.75a1.64 1.64 0 01-1.639 1.64h-7.154a1.64 1.64 0 01-1.64-1.64V5.436zm2.981 6.558c0-.246.2-.447.447-.447h1.79a.447.447 0 010 .895h-1.79a.447.447 0 01-.447-.448zm0 2.385c0-.247.2-.447.447-.447h3.578a.447.447 0 010 .894h-3.578a.447.447 0 01-.447-.447z"
        transform="translate(-441 -9) translate(420.9 5.863)"
        fill="#1A418E"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  );
}

export function DoorSvg(props) {
  return (
    <svg
      width="14px"
      height="20px"
      viewBox="0 0 14 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1851.67 9.776a2.48 2.48 0 013.285-2.077l4.958 1.736a2.48 2.48 0 011.66 2.34v10.877a2.479 2.479 0 01-1.66 2.34l-4.958 1.736a2.48 2.48 0 01-3.285-2.077h-.84a2.48 2.48 0 01-2.48-2.48v-9.916a2.48 2.48 0 012.48-2.48h.84zm-.014 1.653h-.826a.827.827 0 00-.827.826v9.917c0 .456.37.826.827.826h.826v-11.57zm2.753-2.17a.827.827 0 00-1.1.78v14.348c0 .57.563.969 1.1.78l4.958-1.735a.826.826 0 00.553-.78V11.775a.827.827 0 00-.553-.78l-4.958-1.736zm1.379 6.302c.457 0 .826.37.826.826v1.653a.826.826 0 11-1.652 0v-1.653c0-.456.37-.826.826-.826z"
        transform="translate(-1848 -7)"
        fill="#1A418E"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  );
}

export function AddSvg(props) {
  return (
    <svg viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g
        transform="translate(-392 -1329) translate(291.337 1329.91) translate(101.103)"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <circle stroke="#1A418E" fill="#FFF" cx={11} cy={11} r={10.5} />
        <path
          d="M6.936 6.936a.468.468 0 01.661 0L11 10.34l3.403-3.404a.468.468 0 01.66.661L11.66 11l3.404 3.403a.468.468 0 01-.661.66L11 11.66l-3.403 3.404a.468.468 0 01-.66-.661L10.34 11 6.936 7.597a.468.468 0 010-.66"
          fill="#1A418E"
          transform="rotate(45 11 11)"
        />
      </g>
    </svg>
  );
}

export function SmileSvg(props) {
  return (
    <svg viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g
        transform="translate(-1093 -3518) translate(140.145 341) translate(953.145 3177)"
        stroke="#1A418E"
        strokeWidth={2}
        fill="none"
        fillRule="evenodd"
      >
        <circle fill="#FFF" cx={11.1486292} cy={11.1486292} r={10.1486292} />
        <path
          d="M6.505 11.895a4.643 4.643 0 009.287 0"
          fill="#FFF"
          strokeLinecap="round"
        />
        <path strokeLinecap="round" d="M6.5052004 8.5L6.5 8.5" />
        <path strokeLinecap="round" d="M15.5052004 8.5L15.5 8.5" />
      </g>
    </svg>
  );
}

export function SadSvg(props) {
  return (
    <svg viewBox="0 0 24 23" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g
        transform="translate(-1347 -3518) translate(140.145 341) translate(1207.582 3177)"
        stroke="#1A418E"
        strokeWidth={2}
        fill="none"
        fillRule="evenodd"
      >
        <circle fill="#FFF" cx={11.1486292} cy={11.1486292} r={10.1486292} />
        <path
          d="M6.505 11.895a4.643 4.643 0 009.287 0"
          fill="#FFF"
          strokeLinecap="round"
          transform="matrix(1 0 0 -1 0 28.434)"
        />
        <path strokeLinecap="round" d="M6.5052004 8.5L6.5 8.5" />
        <path strokeLinecap="round" d="M15.5052004 8.5L15.5 8.5" />
      </g>
    </svg>
  );
}

export function BriefcaseSvg(props) {
  return (
    <svg
      width="34px"
      height="28px"
      viewBox="0 0 34 28"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1021 1073.921a2.131 2.131 0 00-2.132 2.132v2.131h9.948v-2.131a2.131 2.131 0 00-2.132-2.132H1021zm9.237 4.263v-2.131a3.552 3.552 0 00-3.553-3.553H1021a3.552 3.552 0 00-3.553 3.553v2.131h-6.394a3.552 3.552 0 00-3.553 3.553v7.105c0 .928.593 1.717 1.421 2.01v5.095a3.552 3.552 0 003.553 3.553h22.737a3.552 3.552 0 003.552-3.553v-5.094a2.136 2.136 0 001.421-2.01v-7.106a3.552 3.552 0 00-3.552-3.553h-6.395zm7.105 12.79h-9.947v.71a2.131 2.131 0 01-2.132 2.132h-2.842a2.131 2.131 0 01-2.132-2.132v-.71h-9.947v4.973c0 1.178.955 2.132 2.132 2.132h22.737a2.131 2.131 0 002.131-2.132v-4.973zm-17.053-1.421v-.71c0-1.179.955-2.132 2.132-2.132h2.842c1.177 0 2.132.953 2.132 2.131v.71h10.658a.71.71 0 00.71-.71v-7.105a2.131 2.131 0 00-2.131-2.132h-25.58a2.131 2.131 0 00-2.13 2.132v7.105c0 .392.317.71.71.71h10.657zm2.132-1.421a.71.71 0 00-.71.71v2.842c0 .392.318.71.71.71h2.842a.71.71 0 00.71-.71v-2.842a.71.71 0 00-.71-.71h-2.842z"
        transform="translate(-1007 -1072)"
        fill="#FFF"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  );
}

export function ButtonCorner(props) {
  return (
    <svg
      width="1.9rem"
      height="1.6rem"
      viewBox="0 0 19 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        transform="translate(-966 -1116)"
        fill="#6D2807"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
        d="M966.796967 1116.82681L984.796967 1116.82681 984.796967 1131.23677z"
      />
    </svg>
  );
}

export function ShareArrowSvg(props) {
  return (
    <svg viewBox="0 0 30 25" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1469.674 440.373a1.2 1.2 0 011.308.26l8.4 8.4a1.2 1.2 0 010 1.697l-8.4 8.4a1.2 1.2 0 01-2.049-.848v-3.6h-.6c-6.498 0-12.165 3.561-15.156 8.844a1.2 1.2 0 01-2.244-.601c.086-9.87 8.111-17.843 18-17.843v-3.6c0-.485.292-.924.74-1.109zm1.66 4.006v3.103h-2.4c-6.97 0-12.872 4.57-14.873 10.875a19.746 19.746 0 0114.272-6.075h3v3.103l5.504-5.503-5.504-5.503z"
        transform="translate(-1450 -440)"
        fill="#195AFE"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  );
}

export function CoinsSvg(props) {
  return (
    <svg viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.218 6.986c-.177.174-.237.328-.237.454s.06.279.237.453c.179.177.457.353.83.508.745.31 1.798.51 2.981.51 1.183 0 2.237-.2 2.982-.51.372-.155.65-.331.829-.508.178-.174.238-.327.238-.453s-.06-.28-.238-.454c-.179-.177-.457-.353-.829-.507-.745-.311-1.799-.511-2.982-.511-1.183 0-2.236.2-2.981.51-.373.155-.651.331-.83.508zm7.86 1.667c-.226.163-.491.305-.785.427-.854.357-2.008.568-3.264.568-1.256 0-2.41-.211-3.265-.568a3.892 3.892 0 01-.783-.427v1.731c0 .126.06.279.237.453.179.177.457.353.83.508.745.31 1.798.511 2.981.511 1.183 0 2.237-.2 2.982-.51.372-.156.65-.332.829-.509.178-.174.238-.327.238-.453V8.653zm0 2.944c-.226.163-.491.305-.785.428-.854.356-2.008.567-3.264.567-1.256 0-2.41-.211-3.265-.567a3.892 3.892 0 01-.783-.428v1.731c0 .126.06.28.237.454.179.176.457.352.83.507.745.31 1.798.511 2.981.511.504 0 .987-.037 1.432-.103.257-.308.641-.558 1.086-.756a6.854 6.854 0 011.53-.453v-1.891zm.736 1.787V7.44c0-.383-.188-.713-.457-.978-.268-.265-.638-.485-1.064-.663-.854-.356-2.008-.567-3.264-.567-1.256 0-2.41.211-3.265.567-.425.178-.795.398-1.062.663-.27.265-.457.595-.457.978v8.832c0 .382.188.713.457.978.267.265.637.485 1.062.663.855.356 2.009.567 3.265.567.38 0 .75-.02 1.104-.056v.056c0 .382.188.713.457.979.268.264.637.484 1.063.662.854.356 2.008.567 3.265.567 1.255 0 2.41-.21 3.263-.567.426-.178.796-.398 1.064-.662.27-.266.457-.597.457-.979v-2.944c0-.383-.188-.713-.457-.978-.268-.264-.638-.485-1.064-.663-.854-.356-2.008-.567-3.263-.567-.38 0-.75.02-1.104.056zm5.152 3.365v1.731c0 .126-.06.28-.238.454-.179.176-.457.352-.829.508-.745.31-1.799.51-2.981.51-1.184 0-2.237-.2-2.982-.51-.372-.156-.65-.332-.83-.508-.177-.175-.237-.328-.237-.454v-1.73c.224.162.491.305.784.427.854.356 2.008.567 3.265.567 1.255 0 2.41-.21 3.263-.567.294-.122.56-.265.785-.428zm-8.097-1.213c0 .126.06.28.237.454.18.176.458.352.83.507.745.31 1.798.511 2.982.511 1.182 0 2.236-.2 2.981-.51.372-.156.65-.332.83-.508.177-.175.237-.328.237-.454s-.06-.28-.238-.454c-.179-.177-.457-.352-.829-.507-.745-.31-1.799-.51-2.981-.51-.5 0-.976.034-1.42.1-.646.095-1.211.252-1.653.448-.448.2-.736.423-.875.63a.525.525 0 00-.1.293zm-.736 2.148v-2.148c0-.019 0-.037.002-.056a10.97 10.97 0 01-1.106.056c-1.256 0-2.41-.211-3.265-.567a3.892 3.892 0 01-.783-.428v1.731c0 .126.06.28.237.454.179.176.457.352.83.508.745.31 1.798.51 2.981.51.382 0 .753-.021 1.104-.06z"
        transform="translate(-1342 -905) translate(1328.607 900.457)"
        fill="#FFF"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  );
}

export function AlertSvg(props) {
  return (
    <svg viewBox="0 0 16 14" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.457 1.192a1.035 1.035 0 00-1.775 0L.84 10.93c-.414.69.083 1.568.887 1.568h11.685c.804 0 1.3-.878.887-1.568L8.457 1.192zM6.09.838a1.724 1.724 0 012.958 0l5.842 9.737c.69 1.15-.138 2.612-1.478 2.612H1.727c-1.34 0-2.168-1.463-1.478-2.612L6.09.838zm1.48 3.38c.19 0 .344.154.344.345v2.76a.345.345 0 01-.69 0v-2.76c0-.191.155-.345.345-.345zm0 4.83c.19 0 .344.153.344.344v.69a.345.345 0 01-.69 0v-.69c0-.19.155-.345.345-.345z"
        transform="translate(-1557 -1072) translate(1543.535 1068) translate(14.178 4.207)"
        fill="#1A418E"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  );
}

export function EqualizerSvg(props) {
  return (
    <svg viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M16.053 4.809c.215 0 .389.174.389.388v6.637a1.942 1.942 0 010 3.804v5.085a.388.388 0 01-.777 0v-5.085a1.941 1.941 0 010-3.804V5.197c0-.214.174-.388.388-.388m6.21 0c.215 0 .389.174.389.388v2.756a1.942 1.942 0 010 3.804v8.966a.388.388 0 01-.776 0v-8.966a1.941 1.941 0 010-3.804V5.197c0-.214.173-.388.388-.388m6.21 0c.214 0 .388.174.388.388v8.966a1.942 1.942 0 010 3.804v2.756a.388.388 0 01-.776 0v-2.756a1.941 1.941 0 010-3.804V5.197c0-.214.174-.388.388-.388m-6.21 3.881a1.164 1.164 0 100 2.33 1.164 1.164 0 000-2.33m-6.21 3.882a1.164 1.164 0 100 2.329 1.164 1.164 0 000-2.33m12.42 2.33a1.164 1.164 0 100 2.328 1.164 1.164 0 000-2.328"
        transform="translate(-1555 -1845) translate(1541 1840.428)"
        fill="#FFF"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  );
}

  export function CloseSvg(props) {
    return (
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          d="M1582 130c-5.523 0-10 4.478-10 10s4.477 10 10 10 10-4.478 10-10-4.477-10-10-10m-12 10c0-6.627 5.373-12 12-12s12 5.373 12 12-5.373 12-12 12-12-5.373-12-12m7.293-4.707a.999.999 0 011.414 0l3.293 3.293 3.293-3.293a.999.999 0 111.414 1.414l-3.293 3.293 3.293 3.293a.999.999 0 11-1.414 1.414l-3.293-3.293-3.293 3.293a.999.999 0 11-1.414-1.414l3.293-3.293-3.293-3.293a.999.999 0 010-1.414"
          transform="translate(-1570 -128)"
          fill="#1A418E"
          stroke="none"
          strokeWidth={1}
          fillRule="evenodd"
        />
      </svg>
    )
  }

  export function CloseMobSvg(props) {
    return (
      <svg viewBox="0 0 41 40" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <path
            d="M0 20C0 8.955 8.955 0 20 0s20 8.955 20 20-8.955 20-20 20S0 31.045 0 20"
            fill="#1A418E"
            transform="translate(-945 -341) translate(945.5 341)"
          />
          <path
            d="M12.155 12.155a1.665 1.665 0 012.357 0L20 17.643l5.488-5.488a1.665 1.665 0 012.357 0 1.665 1.665 0 010 2.357L22.357 20l5.488 5.488a1.665 1.665 0 010 2.357 1.665 1.665 0 01-2.357 0L20 22.357l-5.488 5.488a1.665 1.665 0 01-2.357 0 1.665 1.665 0 010-2.357L17.643 20l-5.488-5.488a1.665 1.665 0 010-2.357"
            fill="#FFF"
            transform="translate(-945 -341) translate(945.5 341)"
          />
        </g>
      </svg>
    )
  }

  export function HideSvg(props) {
    return (
        <svg viewBox="0 0 17 12" xmlns="http://www.w3.org/2000/svg"{...props}>
            <path
                d="M30.67 5.441c.124.16.096.39-.065.515l-1.83 1.424a10.532 10.532 0 012.865 2.495 1.474 1.474 0 010 1.85c-1.017 1.28-3.584 3.841-7.86 3.841a9.73 9.73 0 01-4.287-.967l-2.088 1.624a.366.366 0 11-.45-.579l1.83-1.424a10.52 10.52 0 01-2.864-2.495 1.474 1.474 0 010-1.85c1.016-1.281 3.583-3.842 7.859-3.842A9.73 9.73 0 0128.068 7l2.087-1.622a.366.366 0 01.514.063zm-3.254 2.067a9.057 9.057 0 00-3.636-.742c-3.954 0-6.332 2.365-7.285 3.564a.742.742 0 000 .94 9.786 9.786 0 002.916 2.463l8.005-6.225zm-7.271 6.584a9.056 9.056 0 003.635.741c3.954 0 6.332-2.364 7.285-3.564a.742.742 0 000-.939 9.77 9.77 0 00-2.917-2.463l-8.003 6.225z"
                transform="translate(-1533 -733) translate(275.323 728) translate(1242.577 .2)"
                fill="#1A418E"
                stroke="none"
                strokeWidth={1}
                fillRule="evenodd"
            />
        </svg>
    )
  }

export function ShowSvg(props) {
    return (
        <svg viewBox="0 0 23 13" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"{...props}>
            <defs>
                <path id="a" d="M0 0L22.324 0 22.324 13 0 13z" />
            </defs>
            <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                <mask id="b" fill="#fff">
                    <use xlinkHref="#a" />
                </mask>
                <path
                    d="M11.162 1C5.77 1 2.527 4.224 1.227 5.86a1.015 1.015 0 000 1.28C2.527 8.776 5.77 12 11.162 12s8.635-3.224 9.935-4.86a1.015 1.015 0 000-1.28C19.797 4.224 16.554 1 11.162 1M.444 5.239C1.83 3.492 5.332 0 11.162 0s9.33 3.492 10.718 5.239a2.01 2.01 0 010 2.522C20.493 9.508 16.992 13 11.162 13S1.83 9.508.444 7.761a2.01 2.01 0 010-2.522M11.162 4a2.5 2.5 0 100 5 2.5 2.5 0 000-5m-3.5 2.5a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0"
                    fill="#1A418E"
                    fillRule="nonzero"
                    mask="url(#b)"
                />
            </g>
        </svg>
    )
}

export function CalendarSvg(props) {
  return (
    <svg viewBox="0 0 17 18" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M803.547 339.591c.327 0 .593.266.593.593v.989h6.72v-.989a.593.593 0 011.187 0v.989h1.779c1.2 0 2.174.973 2.174 2.174v11.07a2.174 2.174 0 01-2.174 2.174h-12.652a2.174 2.174 0 01-2.174-2.174v-11.07c0-1.2.973-2.174 2.174-2.174h1.78v-.989c0-.327.265-.593.593-.593zm-2.373 2.768a.989.989 0 00-.988.988v1.78h14.628v-1.78a.989.989 0 00-.988-.988h-12.652zm13.64 3.953h-14.628v8.105c0 .545.443.988.988.988h12.652a.989.989 0 00.988-.988v-8.105z"
        transform="translate(-799 -339)"
        fill="#FFF"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  );
}

export function WebSvg(props) {
  return (
    <svg viewBox="0 0 21 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M601.108 755.164h4.549c.055-2.33.422-4.45 1.002-6.045.211-.58.456-1.105.734-1.551a8.512 8.512 0 00-6.285 7.596zm8.483-9.128c-5.385 0-9.75 4.366-9.75 9.75 0 5.385 4.365 9.75 9.75 9.75 5.384 0 9.75-4.365 9.75-9.75 0-5.384-4.366-9.75-9.75-9.75zm0 1.245c-.208 0-.488.114-.82.501-.331.383-.656.977-.942 1.763-.522 1.434-.872 3.404-.928 5.619h5.38c-.056-2.215-.407-4.185-.928-5.62-.286-.785-.612-1.379-.942-1.762-.332-.387-.611-.501-.82-.501zm3.934 7.883c-.056-2.33-.422-4.45-1.003-6.045a8.33 8.33 0 00-.732-1.551 8.51 8.51 0 016.284 7.596h-4.55zm-1.245 1.245h-5.379c.056 2.214.406 4.184.928 5.619.286.786.61 1.379.942 1.762.332.387.612.502.82.502.209 0 .488-.115.82-.502.33-.383.656-.976.942-1.762.521-1.435.872-3.405.927-5.62zm-.49 7.595a8.33 8.33 0 00.732-1.55c.581-1.596.947-3.715 1.003-6.045h4.549a8.51 8.51 0 01-6.284 7.595zm-4.397 0a8.332 8.332 0 01-.734-1.55c-.58-1.596-.947-3.715-1.002-6.045h-4.55a8.512 8.512 0 006.286 7.595z"
        transform="translate(-599 -746)"
        fill="#4A5767"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
        opacity={0.309705462}
      />
    </svg>
  )
}
export function AvatarSvg(props) {
  return (
    <svg viewBox="0 0 21 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1118.7 599.163a8.902 8.902 0 00-6.731 14.729 7.241 7.241 0 014.721-4.273 3.81 3.81 0 01-1.821-3.25 3.823 3.823 0 013.83-3.815 3.823 3.823 0 013.831 3.816 3.81 3.81 0 01-1.821 3.249 7.243 7.243 0 014.721 4.273 8.902 8.902 0 00-6.73-14.728m6.075 15.408a6.387 6.387 0 00-6.076-4.387 6.389 6.389 0 00-6.076 4.387 8.872 8.872 0 006.076 2.396c2.35 0 4.486-.91 6.076-2.396m-15.826-6.507c0-5.384 4.365-9.75 9.75-9.75 5.386 0 9.75 4.366 9.75 9.75a9.722 9.722 0 01-2.894 6.933 9.72 9.72 0 01-6.856 2.817 9.719 9.719 0 01-6.855-2.817 9.722 9.722 0 01-2.895-6.933m9.75-4.663a2.975 2.975 0 00-2.982 2.968 2.975 2.975 0 002.982 2.967 2.975 2.975 0 002.983-2.967 2.975 2.975 0 00-2.983-2.968"
        transform="translate(-1108 -598)"
        fill="#DAE0E7"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}

export function DeleteCrossSvg(props) {
  return (
    <svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M134.654 11.28l3.647 3.645 3.646-3.646a.5.5 0 01.707.707l-3.646 3.647 3.646 3.646a.5.5 0 01-.707.707l-3.646-3.646-3.647 3.646a.5.5 0 01-.707-.707l3.646-3.646-3.646-3.647a.5.5 0 01.707-.707z"
        transform="translate(-707 -690) translate(573.5 679.338)"
        fill="#1A418E"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}

export function RhombiSvg(props) {
  return (
    <svg viewBox="0 0 43 44" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect
        transform="translate(-238 -2634) translate(236.659 2621.8) rotate(45 23.006 34.268)"
        x={6.73833864}
        y={18}
        width={32.5355771}
        height={32.5355771}
        rx={4}
        fill="#FFF"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}

export function RestartSvg(props) {
  return (
    <svg viewBox="0 0 32 27" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M673.941 228.1c-2.993 0-5.687 1.327-7.55 3.455a1.3 1.3 0 11-1.956-1.71c2.329-2.66 5.722-4.345 9.506-4.345 6.977 0 12.6 5.707 12.737 12.739l.634-.648a1.3 1.3 0 111.859 1.817l-2.86 2.926a1.297 1.297 0 01-1.86 0l-2.86-2.925a1.3 1.3 0 111.86-1.818l.626.641c-.138-5.646-4.65-10.132-10.136-10.132m-11.44 6.175c.35 0 .685.14.93.391l2.86 2.925a1.3 1.3 0 11-1.86 1.818l-.626-.641c.138 5.646 4.65 10.132 10.136 10.132 2.993 0 5.688-1.327 7.55-3.455a1.3 1.3 0 111.956 1.71c-2.329 2.66-5.722 4.345-9.506 4.345-6.977 0-12.6-5.707-12.737-12.739l-.633.648a1.3 1.3 0 11-1.859-1.817l2.86-2.926c.244-.25.58-.391.929-.391"
        transform="translate(-779 -876) translate(121 651.4)"
        fill="#FFF"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}

export function WarningSvg(props) {
  return (
    <svg viewBox="0 0 19 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M22.024 14.86a.78.78 0 00-1.339 0l-6.61 11.017a.781.781 0 00.67 1.182h13.22a.78.78 0 00.67-1.182l-6.61-11.016zm-2.677-.802c.91-1.517 3.106-1.517 4.016 0l6.61 11.015c.936 1.561-.188 3.547-2.009 3.547H14.745c-1.82 0-2.944-1.986-2.008-3.547l6.61-11.015zm2.008 3.634c.431 0 .78.349.78.78v3.123a.78.78 0 11-1.56 0v-3.122a.78.78 0 01.78-.781zm0 5.464c.431 0 .78.35.78.78v.781a.78.78 0 11-1.56 0v-.78a.78.78 0 01.78-.78z"
        transform="translate(-1029 -210) translate(1017.174 197.27)"
        fill="#F83434"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}

export function SettingsSvg(props) {
  return (
    <svg viewBox="0 0 13 15" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.5 4.67a6.06 6.06 0 00-.456.017c-.26.02-.494.237-.542.563l-.056.39c-.09.614-.512 1.078-.994 1.336-.08.043-.157.088-.234.136-.465.289-1.078.423-1.654.194l-.368-.147c-.305-.122-.612-.028-.758.187-.171.25-.325.515-.458.79-.113.234-.04.546.217.75l.313.246c.486.384.676.98.66 1.527a3.464 3.464 0 000 .273c.016.547-.174 1.144-.66 1.527l-.313.246c-.258.204-.33.516-.217.75.133.275.287.54.458.79.146.215.453.31.758.187l.368-.146c.576-.23 1.189-.095 1.654.193.077.048.154.093.234.136.482.259.905.722.994 1.335l.056.39c.048.327.282.545.542.564a6.06 6.06 0 00.912 0c.26-.019.494-.237.541-.563l.058-.39c.089-.614.511-1.077.992-1.336.08-.043.158-.088.235-.136.465-.288 1.078-.423 1.654-.193l.367.146c.306.122.613.028.759-.187.171-.25.324-.515.457-.79.113-.234.042-.546-.217-.75l-.312-.246c-.486-.383-.677-.98-.66-1.527a5.19 5.19 0 000-.273c-.017-.547.174-1.143.66-1.527l.312-.246c.259-.204.33-.516.217-.75a6.067 6.067 0 00-.457-.79c-.146-.215-.453-.309-.759-.187l-.367.147c-.576.23-1.19.095-1.654-.194a4.134 4.134 0 00-.235-.136c-.48-.258-.903-.722-.992-1.335l-.058-.39c-.047-.327-.282-.545-.541-.564a6.06 6.06 0 00-.456-.017m-.522-.877a7.196 7.196 0 011.043 0c.747.055 1.266.657 1.364 1.329l.056.39c.039.264.231.514.53.675.097.051.192.106.284.164.288.179.6.22.849.122l.367-.147c.63-.25 1.41-.103 1.831.514.196.288.372.59.525.907.325.673.062 1.423-.47 1.843l-.312.246c-.21.165-.329.456-.319.795a5 5 0 010 .329c-.01.339.11.63.319.795l.312.247c.532.419.795 1.169.47 1.843-.153.316-.329.619-.525.906-.42.617-1.201.764-1.83.514l-.368-.147c-.248-.099-.56-.057-.849.122a5.138 5.138 0 01-.284.164c-.299.161-.491.411-.53.675l-.056.39c-.098.672-.617 1.274-1.364 1.33a7.183 7.183 0 01-1.043 0c-.746-.056-1.266-.658-1.363-1.33l-.057-.39c-.038-.264-.23-.514-.53-.675a4.911 4.911 0 01-.283-.164c-.289-.179-.601-.22-.85-.122l-.366.147c-.63.25-1.41.103-1.831-.514a6.957 6.957 0 01-.525-.906c-.325-.674-.063-1.424.47-1.843l.312-.247c.209-.165.329-.456.318-.795a5 5 0 010-.329c.01-.339-.11-.63-.318-.795l-.312-.246c-.533-.42-.795-1.17-.47-1.843.152-.316.328-.62.525-.907.421-.617 1.2-.764 1.83-.514l.368.147c.248.099.56.057.849-.122.092-.058.187-.113.283-.164.3-.16.492-.411.53-.675l.057-.39c.097-.672.617-1.274 1.363-1.33m.522 5.061a1.942 1.942 0 100 3.885 1.942 1.942 0 000-3.885m-2.839 1.943a2.838 2.838 0 115.676-.001 2.838 2.838 0 01-5.676 0"
        transform="translate(-1474 -9) translate(-50) translate(1515 5.863)"
        fill="#1A418E"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}

export function RocketSvg(props) {
  return (
    <svg viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1529.444 212.656a14.695 14.695 0 0114.425-7.022 2.324 2.324 0 012.018 2.018 14.695 14.695 0 01-7.022 14.424l-1.471.883v3.204a3.595 3.595 0 01-1.35 2.81l-3.148 2.518c-1.57 1.255-3.896.138-3.896-1.873v-1.82a3.598 3.598 0 01-3.37-.957l-.95-.95a3.595 3.595 0 01-.957-3.37h-1.821c-2.01 0-3.128-2.327-1.872-3.897l2.518-3.147a3.595 3.595 0 012.808-1.35h3.205l.883-1.471zm-2.323 3.87h-1.765c-.363 0-.708.165-.936.449l-2.518 3.147h3.062l2.157-3.597zm4.277 10.03l3.598-2.158v1.765c0 .365-.166.709-.451.937l-3.147 2.518v-3.061zm12.116-18.549a12.296 12.296 0 00-12.014 5.883l-5.304 8.84a1.2 1.2 0 00.18 1.466l.95.948c.388.39.992.464 1.464.18l8.841-5.304a12.298 12.298 0 005.883-12.013zm-2.874 2.874a1.198 1.198 0 010 1.696l-1.2 1.199a1.2 1.2 0 01-1.695-1.696l1.2-1.199a1.198 1.198 0 011.695 0zm-16.787 16.787a1.198 1.198 0 010 1.696l-1.2 1.199a1.2 1.2 0 01-1.695-1.696l1.2-1.199a1.198 1.198 0 011.695 0z"
        transform="translate(-1519 -205)"
        fill="#FFF"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}

export function Checked(props) {
  return (
    <svg
      viewBox="0 0 44.0 45.0"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <clipPath id="a">
          <path d="M1894 0v1173H0V0h1894z" />
        </clipPath>
        <clipPath id="b">
          <path d="M21.64 0c11.952 0 21.641 9.689 21.641 21.64 0 11.952-9.689 21.641-21.64 21.641C9.689 43.281 0 33.592 0 21.641 0 9.689 9.689 0 21.64 0z" />
        </clipPath>
      </defs>
      <g clipPath="url(#a)" transform="translate(-637 -466)">
        <g
          clipPath="url(#b)"
          transform="translate(594.5 388.5) translate(42.763 78.36)"
        >
          <path
            fill="#369AFE"
            d="M0 0L43.2810218 0 43.2810218 43.2810218 0 43.2810218 0 0z"
          />
        </g>
        <path
          d="M0 4.448L5.33 9.68 13.6 0"
          stroke="#FFF"
          strokeWidth={3}
          fill="none"
          strokeLinecap="round"
          strokeMiterlimit={10}
          transform="translate(594.5 388.5) translate(42.763 78.36) translate(14.84 16.8)"
        />
      </g>
    </svg>
  )
}

export function CopySvg(props) {
  return (
    <svg
      viewBox="0 0 32.0 37.0"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <clipPath id="a">
          <path d="M1894 0v1548H0V0h1894z" />
        </clipPath>
        <clipPath id="b">
          <path d="M18.5 0a.81.81 0 01.57.235l11.26 11.26a.81.81 0 01.235.57v14.478c0 2.222-1.8 4.022-4.022 4.022H24.13v2.413C24.13 35.2 22.33 37 20.11 37H4.022A4.021 4.021 0 010 32.978V10.457c0-2.222 1.8-4.022 4.022-4.022h2.413V4.022C6.435 1.8 8.235 0 10.457 0H18.5zM6.435 8.043H4.022a2.413 2.413 0 00-2.413 2.414v22.521a2.413 2.413 0 002.413 2.413h16.087a2.413 2.413 0 002.413-2.413v-2.413H10.457a4.021 4.021 0 01-4.022-4.022v-18.5zm11.26-6.434h-7.238a2.413 2.413 0 00-2.414 2.413v22.521a2.413 2.413 0 002.414 2.414h16.086a2.413 2.413 0 002.414-2.414V12.87h-7.24a4.021 4.021 0 01-4.021-4.022v-7.24zm1.61 1.137v6.102a2.413 2.413 0 002.412 2.413h6.102l-8.515-8.515z" />
        </clipPath>
      </defs>
      <g clipPath="url(#a)" transform="translate(-1246 -782)">
        <g
          clipPath="url(#b)"
          transform="translate(614.5 263) translate(632.435 519)"
        >
          <path fill="#293644" d="M0 0L30.5652174 0 30.5652174 37 0 37 0 0z" />
        </g>
      </g>
    </svg>
  )
}

export function TrianglesSvg(props) {
  return (
    <svg viewBox="0 0 21 10" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g
        transform="translate(-611 -4641) translate(465.5 4265) translate(0 370) translate(146.089 6.151)"
        fill="#1B418E"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      >
        <path
          transform="rotate(90 17.095 4.453)"
          d="M17.094619 1.42702956L21.5474679 7.47866839 12.64177 7.47866839z"
        />
        <path
          transform="rotate(90 10.25 4.453)"
          d="M10.2506758 1.42702956L14.7035247 7.47866839 5.7978268 7.47866839z"
        />
        <path
          transform="rotate(90 3.026 4.453)"
          d="M3.02581941 1.42702956L7.47866839 7.47866839 -1.42702956 7.47866839z"
        />
      </g>
    </svg>
  )
}

export function NotebookIcon(props) {
  return (
    <svg
      width="2.3rem"
      height="2.2rem"
      viewBox="0 0 23 22"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M487.024 6552.8a2.75 2.75 0 012.75-2.75h11a2.75 2.75 0 012.75 2.75v.682a1.744 1.744 0 011.487.495l1.586 1.587a1.748 1.748 0 010 2.474l-3.073 3.074v7.689a2.75 2.75 0 01-2.75 2.75h-11a2.75 2.75 0 01-2.75-2.75v-1.25h-1.25a.75.75 0 010-1.5h1.25v-4.5h-1.25a.75.75 0 010-1.5h1.25v-4.5h-1.25a.75.75 0 010-1.5h1.25v-1.25zm1.5 2.75h.25a.75.75 0 000-1.5h-.25v-1.25c0-.69.56-1.25 1.25-1.25h11c.69 0 1.25.56 1.25 1.25v1.69l-7.487 7.488a1.75 1.75 0 00-.513 1.236v3.337h3.336a1.75 1.75 0 001.237-.514l3.427-3.426v6.19c0 .69-.56 1.25-1.25 1.25h-11c-.69 0-1.25-.56-1.25-1.25v-1.25h.25a.75.75 0 000-1.5h-.25v-4.5h.25a.75.75 0 000-1.5h-.25v-4.5zm15.427-.512a.252.252 0 00-.354 0l-8 8a.25.25 0 00-.073.177v1.836h1.836a.25.25 0 00.177-.074l8-8a.252.252 0 000-.354l-1.586-1.585z"
        transform="translate(-485 -6550)"
        fill="#E7526A"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}